import { css } from '../consts/styled';

const sizes = {
  contentToolbar: 1560,
  contentToolbarLg: 1504,
  contentToolbarMid: 1454,
  contentToolbarIconsOnly: 1388,
  tabletLandscape: 1200,
  laptop: 1130,
  tablet: 900,
  phone: 600,
  ultraSmallPhone: 400,
};

// TODO(Ivan): add ${} functionality inside media query
const media = Object.keys(sizes).reduce((acc, device) => {
  acc[device] = (...args) => css`
    @media (max-width: ${sizes[device]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});

export default media;
export { media };

media.sizes = sizes;

media.getScreenSize = () => {
  const w = window;
  const d = document;
  const e = d.documentElement;
  const g = d.getElementsByTagName('body')[0];
  const x = w.innerWidth || e.clientWidth || g.clientWidth;
  const y = w.innerHeight || e.clientHeight || g.clientHeight;
  return { x, y };
};